import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=198c5ef6&scoped=true&"
import script from "./OrderList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OrderList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=198c5ef6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198c5ef6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrderItem: require('/usr/www/nuxt/components/Order/OrderItem.vue').default})
